import React from 'react';
import { useParams } from 'react-router-dom';
import { OrderPrinting } from 'components/Pages/Scheduling/OrderPrinting';

export const OrderPrintingPage: React.FC = () => {
  const { id } = useParams() as { id: string };

  return <OrderPrinting orderId={id} />;
};
